import React, { useMemo } from 'react'

const RenderStyleEl = ({ uid, style }) => {
  const styleText = useMemo(() => String(style).replace(/\r|\n|[\s]{2,}/g, ''), [style])
  return (
    <style id={uid} data-uid={uid} type="text/css" suppressHydrationWarning={true}>
      {styleText}
    </style>
  )
}

export function StyleElement({ uid, style, styleEl }) {
  if (style) {
    return <RenderStyleEl uid={uid} style={style} />
  } else {
    return (
      <style key={uid} id={uid} data-uid={uid} type="text/css" suppressHydrationWarning={true}>
        {styleEl}
      </style>
    )
  }
}
